<template>
  <v-row wrap class="mx-0">
    <v-col v-if="!showTitle" cols="12"  class="mx-0 px-0 my-0 py-0">
         <app-grant-header :number="item.number" :start="item.start" :end="item.end"></app-grant-header>
    </v-col>
    <v-col v-else cols="12"  class="mx-0 px-0 my-0 py-0">
        <a v-if="item.grant_info.url_grant" :href ="item.grant_info.url_grant">
           <app-grant-header :number="item.number" :start="item.start" :end="item.end"></app-grant-header>
        </a>
        <router-link  v-else :to="{name:'infos',params:{id:item.id}}" class="grey--text text--darken-3 pointer my-0 py-0" tag="div">
            <a>
              <app-grant-header :number="item.number" :start="item.start" :end="item.end"></app-grant-header>
            </a>
        </router-link>
    </v-col>

    <v-col cols="12" class="mx-0 px-0 my-0 pt-0 pb-0">
      <p v-if="item.grant_info.grantor" class="caption  my-0 py-0">
        <span class="font-weight-bold ">Grantor:</span>
        <span v-html="item.grant_info.grantor"></span>
      </p>
    </v-col>
    <v-col v-if="showTitle" cols="12" class="mx-0 px-0 mt-0 mb-1 py-0">
        <a v-if="item.grant_info.url_grant" :href ="item.grant_info.url_grant"
            class="blue--text text--darken-4 pointer font-weight-medium">
            <span v-html="item.grant_info.title"></span>
        </a>
        <router-link  v-else :to="{name:'infos',params:{id:item.id}}" tag="div"
            class="pointer font-weight-medium my-0 py-0">
            <a class="blue--text text--darken-4">
                <span v-html="item.grant_info.title"></span>
            </a>
        </router-link>
    </v-col>
  </v-row>
</template>
<script>
import grantHeader from './GrantHeader.vue';
export default {
  props:['showTitle','item'],
  components:{
      appGrantHeader:grantHeader,
  }
}
</script>
